module.exports = __webpack_public_path__ + "static/media/check_circle_green.c9a0454b.svg";